import React from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { formatDate } from '../../utils/redemptionHelpers';
import { maskPhone } from '../../utils/redemptionHelpers';

const RedemptionInfoCard = ({ profile, showPhone, setShowPhone, isFinance, isSupport }) => {
  const maskedPhoneNumber = React.useMemo(() => {
    const phoneNumber = profile?.personal?.mobile || profile?.phoneFull;
    return maskPhone(phoneNumber);
  }, [profile?.personal?.mobile, profile?.phoneFull]);

  return (
    <div className="bg-white border border-gray-200 rounded-md p-4 sm:p-6 shadow-sm">
      <div className="space-y-6">
        {/* Header Section */}
        <div className="relative">
          <div>
            <div className="text-xl font-bold text-gray-900">
              {profile?.personal?.full_name || profile?.name || 'Subscriber'}
            </div>
            <div className="text-sm text-gray-600 flex items-center space-x-2 mt-1">
              <span>
                Mobile No: {
                  (isFinance || isSupport) 
                    ? (profile?.personal?.mobile || profile?.phoneFull) 
                    : (showPhone ? (profile?.personal?.mobile || profile?.phoneFull) : maskedPhoneNumber)
                }
              </span>
              {!(isFinance || isSupport) && (
                <button
                  onClick={() => setShowPhone(v => !v)}
                  className="text-gray-400 hover:text-gray-600"
                  aria-label={showPhone ? 'Hide phone' : 'Show phone'}
                >
                  {showPhone ? <FaEyeSlash /> : <FaEye />}
                </button>
              )}
            </div>
          </div>
        </div>
        
        {/* Details Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8">
          <div className="space-y-4">
            <div>
              <div className="text-xs text-gray-500 mb-1">REF CODE</div>
              <div className="text-sm font-medium text-gray-900">{profile?.subscription || 'N/A'}</div>
            </div>
            <div>
              <div className="text-xs text-gray-500 mb-1">Validity Period</div>
              <div className="text-sm font-medium text-gray-900">
                {(() => {
                  const validPeriod = profile?.valid_period;
                  if (!validPeriod) return 'N/A';
                  
                  // Handle object with start_date and end_date
                  if (typeof validPeriod === 'object' && validPeriod !== null && validPeriod.start_date && validPeriod.end_date) {
                    const startFormatted = formatDate(validPeriod.start_date);
                    const endFormatted = formatDate(validPeriod.end_date);
                    return `${startFormatted} - ${endFormatted}`;
                  }
                  
                  // Handle string format
                  return formatDate(validPeriod);
                })()}
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <div className="text-xs text-gray-500 mb-1">Plan</div>
              <div className="text-sm font-medium text-gray-900">{profile?.plan || 'N/A'}</div>
            </div>
            <div>
              <div className="text-xs text-gray-500 mb-1">KYC Status</div>
              <span className="inline-flex px-3 py-1 text-xs font-semibold rounded-md bg-green-500 text-white w-fit">
                {profile?.kyc || 'N/A'}
              </span>
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <div className="text-xs text-gray-500 mb-1">Status</div>
              <span className={`inline-flex px-3 py-1 text-xs font-semibold rounded-md w-fit ${
                profile?.status === 'Active' ? 'bg-green-500 text-white' : 'bg-yellow-500 text-white'
              }`}>
                {profile?.status || 'N/A'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedemptionInfoCard;

